import React from 'react';
import ServicesLanding from '../../components/Servicios/ServicesLanding';
import CustomSolutions from '../../components/Servicios/CustomSolutions';
import ServicesGallery from '../../components/Servicios/ServicesGallery';

const Servicios = () => {
  return (
      <main>
        <section className='services-section-body'>
            <ServicesLanding />
            <CustomSolutions />
            <ServicesGallery />
        </section>
      </main>
  );
};

export default Servicios;